import { render } from "./CustomDisplayComponentControl.vue?vue&type=template&id=8451620a&ts=true"
import script from "./CustomDisplayComponentControl.vue?vue&type=script&lang=ts"
export * from "./CustomDisplayComponentControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/workflow/infrastructure/component/rete/customization/CustomDisplayComponentControl.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8451620a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8451620a', __exports__)) {
    api.reload('8451620a', __exports__)
  }
  
  module.hot.accept("./CustomDisplayComponentControl.vue?vue&type=template&id=8451620a&ts=true", () => {
    api.rerender('8451620a', render)
  })

}


export default __exports__